import { Controller } from 'react-hook-form';

import { AppElement, AppFC } from '../../../interfaces';
import { FormInputProps } from './types';

import { Input, Label } from '../../Atoms';

export const FormInput: AppFC<FormInputProps> = ({
  label,
  control,
  error,
  name,
  className,
  children,
  ...rest
}): AppElement => (
  <Label className={className}>
    {!!label && <h6 className={`${error ? 'text-error' : ''}`}>{label}</h6>}
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Input
          error={error}
          {...field}
          {...rest}
        />
      )}
    />
  </Label>
);
